import { deleteCookies } from "../helper/CookieUtil";

const REDIRECT_MESSAGE = "Confirm and proceed to new page?";
const REDIRECT_CANCEL_MESSAGE = "User cancelled redirection.";

export function getResult(url: string) {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/xml",
    },
    credentials: "include",
  }).then((response) => {
    if (response?.redirected && response?.url.includes("logout")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}/`;
    } else if (response?.url?.toLowerCase().includes("/login?error=")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = response?.url;
    } else if (response?.redirected) {
      if (window.confirm(REDIRECT_MESSAGE)) {
        window.localStorage.clear();
        window.location.href = response?.url;
      } else {
        console.log(REDIRECT_CANCEL_MESSAGE);
      }
    }
    return response;
  });
}

export function getJsonResult(url: string) {
  return fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).then((response) => {
    if (response?.redirected && response?.url.includes("logout")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}/`;
    } else if (response?.url?.toLowerCase().includes("/login?error=")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = response?.url;
    } else if (response.redirected) {
      if (window.confirm(REDIRECT_MESSAGE)) {
        window.localStorage.clear();
        window.location.href = response?.url;
      } else {
        console.log(REDIRECT_CANCEL_MESSAGE);
      }
    }
    return response;
  });
}

export function put(url: string, data: any) {
  return fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
    credentials: "include",
  }).then((response) => {
    if (response?.redirected && response?.url.includes("logout")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}/`;
    } else if (response?.url?.toLowerCase().includes("/login?error=")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = response?.url;
    } else if (response.redirected) {
      if (window.confirm(REDIRECT_MESSAGE)) {
        window.localStorage.clear();
        window.location.href = response?.url;
      } else {
        console.log(REDIRECT_CANCEL_MESSAGE);
      }
    }
    return response;
  });
}

export function post(url: string, data: any) {
  return fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
    credentials: "include",
  }).then((response) => {
    if (response?.redirected && response?.url.includes("logout")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}/`;
    } else if (response?.url?.toLowerCase().includes("/login?error=")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = response?.url;
    } else if (response.redirected) {
      if (window.confirm(REDIRECT_MESSAGE)) {
        window.localStorage.clear();
        window.location.href = response?.url;
      } else {
        console.log(REDIRECT_CANCEL_MESSAGE);
      }
    }
    return response;
  });
}

export function deleteService(url: string) {
  return fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  }).then((response) => {
    if (response?.redirected && response?.url.includes("logout")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = `${process.env.REACT_APP_BACKEND_URL}/`;
    } else if (response?.url?.toLowerCase().includes("/login?error=")) {
      window.localStorage.clear();
      deleteCookies();
      window.location.href = response?.url;
    } else if (response.redirected) {
      if (window.confirm(REDIRECT_MESSAGE)) {
        window.localStorage.clear();
        window.location.href = response?.url;
      } else {
        console.log(REDIRECT_CANCEL_MESSAGE);
      }
    }
    return response;
  });
}
